import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col lg:flex-row gap-0 rounded-2xl overflow-hidden">
          <div className="lg:w-1/2 relative h-64 md:h-80 lg:h-auto overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20flowing%20warm%20coral%20and%20cream%20gradients%2C%20soft%20organic%20shapes%2C%20modern%20editorial%20design%2C%20clean%20minimalist%20aesthetic%2C%20warm%20beige%20and%20terracotta%20tones%2C%20elegant%20textured%20background%2C%20sophisticated%20magazine%20style&width=1000&height=700&seq=cta-home-bg-01&orientation=landscape"
              alt="订阅91爆料推送"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/20 to-transparent"></div>
            <div className="absolute left-6 top-6">
              <span className="inline-block px-3 py-1 rounded-full bg-white/20 backdrop-blur-sm text-white text-xs font-medium">
                不错过任何一个瓜
              </span>
            </div>
            <div className="absolute left-6 bottom-6">
              <p className="text-2xl md:text-3xl font-bold font-heading text-white leading-tight">
                第一时间<br />获取最新爆料
              </p>
            </div>
          </div>

          <div className="lg:w-1/2 bg-background-100 flex flex-col items-center justify-center text-center p-8 md:p-12 lg:p-14">
            <h3 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-4">
              下载App · 吃瓜更快一步
            </h3>
            <p className="text-sm text-foreground-600 max-w-md mb-8 leading-relaxed">
              下载91爆料网官方App，第一时间接收推送通知，随时随地吃最新鲜的瓜。更有独家深度调查内容只在App端发布。
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3">
              <Link
                to="/about"
                className="whitespace-nowrap px-6 py-3 bg-foreground-900 text-background-50 text-sm font-semibold rounded-md hover:bg-foreground-800 transition-colors cursor-pointer"
              >
                了解更多
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
              <Link
                to="/category/zuixin-dagua"
                className="whitespace-nowrap px-6 py-3 border border-foreground-300/60 text-foreground-700 text-sm font-medium rounded-md hover:border-foreground-400 transition-colors cursor-pointer"
              >
                浏览最新爆料
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}